import PropTypes from 'prop-types';
import React from 'react';

import {
  containerStyle,
  headerStyle,
  subtextStyle,
  titleStyle,
  charCountStyle,
  inputLabelStyle,
  textAreaStyle,
} from './styles';

const StoreDescription = ({ description, onChange }) => (
  <div style={containerStyle}>
    <div style={headerStyle}>
      <h2 style={titleStyle}>Store Description</h2>
      <span style={subtextStyle}>Description shown in Google</span>
    </div>
    <div>
      <label htmlFor="storeDescription" style={inputLabelStyle}>
        Nike Store Description
      </label>
      <textarea
        id="storeDescription"
        maxLength={255}
        placeholder="Enter store description..."
        style={textAreaStyle}
        value={description}
        onChange={(e) => onChange(e.target.value)}
      />
      <div style={charCountStyle}>
        {description.length} / 255 characters
      </div>
    </div>
  </div>
);

StoreDescription.propTypes = {
  description: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StoreDescription;
